// extracted by mini-css-extract-plugin
export var centerList = "_kf-6";
export var centerLoc = "_kf-a";
export var centerName = "_kf-9";
export var centerOptionBody = "_kf-8";
export var centerRow = "_kf-7";
export var centerStatus = "_kf-b";
export var empty = "_kf-5";
export var externalIcon = "_kf-c";
export var fieldHeader = "_kf-2";
export var fieldHelp = "_kf-4";
export var fieldLabel = "_kf-3";
export var panel = "_kf-0";
export var removeBtn = "_kf-d";
export var section = "_kf-1";